<template>
  <div class="main">
    <div class="yym">
      <div class="titlename">
        <div class="line"></div>
        <span>更多应用</span>
      </div>
      <div class="gongg">
        <div
          class="gonggitem"
          v-for="(value, index) in fsylist"
          :key="index"
          @click="changeview(value.to)"
        >
          <img :src="value.icon" alt="" />
          <span>{{ value.name }}</span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Vue from "vue";
import { Grid, GridItem, NoticeBar } from "vant";
import { Dialog } from "vant";
Vue.use(Grid);
Vue.use(GridItem);
Vue.use(NoticeBar);
export default {
  data() {
    return {
      timeOutEvent: null,
      add: false,
      shouyelist: [],
      currhouse: [],
      moduleList: [
        {
          icon: require("../../assets/icon/wyjj.png"),
          name: "小区概况",
          to: "/wyfw/wyjj",
        },
        // {
        // 	icon: require("../../assets/dj.png"),
        // 	name: "党建引领",
        // 	to: '/djindex'
        // },
        {
          icon: require("../../assets/icon/ts.png"),
          name: "投诉建议",
          to: "/tsindex?type=ts",
        },
        {
          icon: require("../../assets/icon/xqgg.png"),
          name: "小区公告",
          to: "/common/list/xqgs",
        },
        {
          icon: require("../../assets/icon/wyqy.png"),
          name: "物业企业",
          to: "/wyqy",
        },
        {
          icon: require("../../assets/icon/wyfw.png"),
          name: "物业服务",
          to: "/wyfw",
        },
        {
          icon: require("../../assets/icon/tsbx.png"),
          name: "报事报修",
          to: "/tsbx?type=bx",
        },
        {
          icon: require("../../assets/icon/wxzj.png"),
          name: "维修资金",
          to: "/wxzj",
        },
        {
          icon: require("../../assets/icon/gzz.png"),
          name: "执法工作站",
          to: "/zhzfz",
        },
        {
          icon: require("../../assets/icon/bmfw.png"),
          name: "便民服务",
          to: "/bmfw",
        },
        {
          icon: require("../../assets/icon/jf.png"),
          name: "业主缴费",
          to: "/wyfw/jflist",
        },
        {
          icon: require("../../assets/icon/gs.png"),
          name: "收支公示",
          to: "/wyqy/szgs/index",
        },
      ],
      fsylist: [
        {
          icon: require("../../assets/icon/gzz.png"),
          name: "执法工作站",
          to: "/zhzfz",
        },
        //2024-04-03需求隐藏维修资金
        // {
        //   icon: require("../../assets/icon/wxzj.png"),
        //   name: "维修资金",
        //   to: "/wxzj",
        // },
      ],
      zan: [
        {
          icon: require("../../assets/icon/yzjc.png"),
          name: "业主决策",
          to: "/yzjc",
        },
        {
          icon: require("../../assets/icon/shjf.png"),
          name: "业主缴费",
          to: "/wyfw/shjf",
        },
      ],
    };
  },
  watch: {
    shouyelist(newval, oldval) {
      var names = newval.map((item) => {
        return item.name;
      });
      localStorage.setItem("shouyeitems", JSON.stringify(names));
    },
  },
  mounted() {},
  methods: {
    changeview(path, id) {
      if (path == "/wxzj") {
        if (sessionStorage.getItem("currentHouseUserType") == 1) {
          this.$router.push({ path: path, query: { type: "syx" } });
        } else {
          Dialog.alert({
            message: "您不是房主,无权限",
          }).then(() => {});
        }
        return;
      }
      this.$router.push({
        path,
        query: {
          id,
        },
      });
    },
    gtouchstart(item) {
      var that = this;
      that.timeOutEvent = setTimeout(function () {
        that.add = true;
      }, 500); //这里设置定时器，定义长按500毫秒触发长按事件，时间可以自己改，个人感觉500毫秒非常合适
      return false;
    },
    //手释放，如果在500毫秒内就释放，则取消长按事件，此时可以执行onclick应该执行的事件
    gtouchend(item) {
      clearTimeout(this.timeOutEvent); //清除定时器
      if (this.timeOutEvent != 0) {
        //这里写要执行的内容（尤如onclick事件）
      }
      return false;
    },
    //如果手指有移动，则取消所有事件，此时说明用户只是要移动而不是长按
    gtouchmove() {
      clearTimeout(this.timeOutEvent); //清除定时器
      this.timeOutEvent = 0;
    },
  },
};
</script>
<style lang="less" scoped>
.main {
  height: 100%;
  width: 100%;
}
.yym {
  padding: 10px;
}
.jia {
  color: #00b5ff;
  font-size: 25px;
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: center;
  top: 0;
  right: 0;
  height: 20px;
}
.titlename {
  height: 20px;
  display: flex;
  align-items: center;
  .line {
    height: 23px;
    width: 4px;
    border-radius: 2px;
    background-color: #00b5ff;
  }
  span {
    margin-left: 10px;
  }
}
.yy {
  width: 100%;
  height: 6px;
  background-color: rgb(244, 244, 244);
}
.gongg {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  background-color: white;
  .gonggitem {
    height: 65px;
    width: 21%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    margin-top: 10px;
    margin-left: 2%;
    position: relative;
    img {
      height: 50%;
      width: 40%;
    }
    span {
      font-size: 13px;
      color: #666666;
      margin-top: 5px;
      text-align: center;
    }
  }
  .gonggitem:not(:nth-child(4n)) {
    margin-right: 2%;
  }
}
</style>